var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 282,
    viewBox: "0 0 281 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.548 206.178C251.661 164.665 247.343 101.683 205.904 65.5057C164.464 29.3279 101.596 33.6534 65.4827 75.167C29.3696 116.681 33.6874 179.662 75.1267 215.84C116.566 252.017 179.435 247.692 215.548 206.178Z",
    fill: "#191F29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.356 199.9C241.008 162.365 237.104 105.42 199.637 72.7102C162.169 39.9999 105.326 43.9109 72.6744 81.4455C40.0226 118.98 43.9265 175.925 81.3941 208.635C118.862 241.345 175.705 237.434 208.356 199.9Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.124 141.087C176.304 136.946 178.211 131.53 178.211 125.797V124.522C178.211 111.462 168.036 100.632 154.999 99.6761V90.4383H138.465V99.6761H131.787V90.4383H115.252V99.6761H111.437H103.169V116.24H111.437V134.079V150.643V170.393H103.169V186.957H111.437H115.252V194.602H131.787V186.957H138.465V194.602H154.999V186.957H155.635C169.944 186.957 181.391 175.489 181.391 161.155V159.562C181.391 152.554 178.211 145.546 173.124 141.087ZM128.289 116.24H131.787H153.727C158.179 116.24 161.995 120.063 161.995 124.522V125.797C161.995 130.256 158.179 134.079 153.727 134.079H128.289V116.24ZM165.174 161.155C165.174 166.252 161.041 170.393 155.953 170.393H131.787H128.289V150.643H153.727H155.953C161.041 150.643 165.174 154.784 165.174 159.881V161.155Z",
    fill: "#191F29"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.36e06d4690df1d0c1150ade2c5bcfc76.svg";
export { ForwardRef as ReactComponent };